import { IVendorConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorConfigurationRequest';
import { IVendorInitiateRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorInitiateRequest';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { IVendorReConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorReConfigurationRequest';
import {
  IVendorConnectConfirmation,
  IVendorConnectInitResponse
} from '@portal/app/dashboard/integrations/models/vendor/VendorIntegrationModels';
import { VendorIdSource } from '@portal/app/dashboard/integrations/shared/constants';
import { VendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vendor-handler';
import { map } from 'lodash-es';
import { IVendorAccounts } from '@portal/app/dashboard/integrations/models/IVendorAccounts';

export class SteelHouseHandler implements VendorHandler {
  prepareRequestObjectToInitiateVendor(): IVendorInitiateRequest {
    return {
      queryParams: {},
      pathParams: { vendorId: VendorIdSource.steelhouse }
    };
  }

  handleVendorInitiateResponse(data: IVendorConnectInitResponse): void {
    // eslint-disable-next-line no-console
    console.log(`${VendorIdSource.steelhouse} initiation handler: ${data}`);
    this.confirmVendor();
  }

  confirmVendor(): IVendorConnectConfirmation {
    throw new Error('Method not implemented.');
  }

  prepareRequestObjectToConfigureVendor(
    accounts: IVendorAccounts[]
  ): IVendorConfigurationRequest {
    return {
      vendorId: VendorIdSource.steelhouse,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId,
        clientAccountName: account.accountName
      }))
    };
  }

  prepareRequestToConfirmVendor(
    confirmationData: Record<string, string>
  ): IVendorOAuthConfirmationRequest {
    return {
      userId: confirmationData.userId || '',
      userSecret: confirmationData.userSecret || '',
      apiKey: confirmationData.apiKey
    };
  }

  prepareRequestObjectToReConfigureVendor(
    accounts: IVendorAccounts[],
    dsInstanceIds: number[]
  ): IVendorReConfigurationRequest {
    return {
      vendorId: VendorIdSource.steelhouse,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId
      })),
      dsInstanceIds
    };
  }
}
